// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"30330418","239":"e054d8cb","455":"49526734"}[chunkId] + ".chunk.js";
};